import { createApp } from "vue";
import App from "./App.vue";

import MessageBox from "@/components/MessageBox/index.js";
import router from "./router";
import ElementPlus from "element-plus";
import { ElNotification } from "element-plus";
// import "element-plus/lib/theme-chalk/index.css";
import 'element-plus/dist/index.css'
import RecordHeader from "@/views/record/header.vue";
const app = createApp(App);
app.component("RecordHeader", RecordHeader);
import "./common.scss";
import store from "@/store";


// Vue 渲染/生命周期错误兜底（避免错误直接打断页面交互）
app.config.errorHandler = (err, instance, info) => {
  // 保留到控制台，方便排查
  console.error("[Vue errorHandler]", info, err);
};

// 浏览器运行时错误兜底
// 注意：webpack-dev-server 的 overlay 会监听 window error 并全屏盖住页面；
// ResizeObserver 的浏览器警告经常被 overlay 误当成“运行时错误”，这里仅在开发环境拦截它。
const isDev =
  typeof process !== "undefined" && process.env && process.env.NODE_ENV === "development";

window.addEventListener(
  "error",
  (event) => {
    const msg = event?.message || "";
    if (
      isDev &&
      /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i.test(msg)
    ) {
      // 关键：用 capture 阶段 + stopImmediatePropagation，阻止 overlay 抢先处理
      event.preventDefault?.();
      event.stopImmediatePropagation?.();
      return;
    }
    console.error("[window error]", msg || event);
  },
  true
);

// 全局兜底：避免未捕获的 Promise rejection 触发 devServer 红色遮罩层
window.addEventListener("unhandledrejection", (event) => {
  const reason = event && event.reason;
  // 常见后端返回结构：{ code, msg }
  if (reason && typeof reason === "object" && reason.msg) {
    ElNotification.warning({ message: reason.msg });
  }
  event.preventDefault();
});

app.use(ElementPlus);
app.use(MessageBox);
app.use(store);
app.use(router).mount("#app");
